import { useSelector } from 'react-redux'

import { translate } from '@/utils/translations'

const PromoCodeDiscount = () => {
  const hasAppliedPromoCode = useSelector(
    state => state.cart.promoCode.hasAppliedPromoCode
  )
  const promoCodeName = useSelector(state => state.cart.promoCode.name)
  const promoCodeAmount = useSelector(state => state.cart.promoCode.amount)

  return (
    <If condition={hasAppliedPromoCode}>
      <li>
        {translate('common.total_discount')}
        <span className='u-push-quarter--left u-weight--bold'>
          {promoCodeName}
        </span>
        <span className='u-float--right'>
          {`– ${promoCodeAmount}`}
        </span>
      </li>
    </If>
  )
}

export default PromoCodeDiscount
